import React from 'react'

export default function Booking() {
  return (
    <div >
        <h1 className='text-xl font-bold text-black text-center my-10 text-red-500'>This page is comming soon...</h1>
    </div>
  )
}
